import { time } from "../utils/time";
import { TEAM_IDS } from "./TeamIds";

export const TEAM_TIME_TO_FIRST_TOKEN_TIMEOUT_OVERRIDES_IN_MS: Record<
  string,
  number | null
> = {
  [TEAM_IDS.WYND_LABS_GRASS]: time.minutesToMilliseconds(10),
  [TEAM_IDS.TENACITY_LABS]: time.minutesToMilliseconds(2),
  [TEAM_IDS.SHIVAM_PROFOUND_AI]: time.minutesToMilliseconds(2),
};
